/* eslint-disable @typescript-eslint/no-floating-promises */
import { QueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

export const refetchUserOnError = (err: unknown, queryClient: QueryClient) => {
  if (axios.isAxiosError(err)) {
    const axiosErr = err as AxiosError;
    if (axiosErr.response?.status === 401) {
      queryClient.invalidateQueries(
        {
          queryKey: ['auth-user'],
        },
        {
          cancelRefetch: false,
        }
      );
    }
  }
};
